import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import NavBar from "../Comp/NavBar";
import Footer from "../Comp/Footer";

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [order, setOrder] = useState(location.state?.order || null);
  const [loading, setLoading] = useState(!order);

  useEffect(() => {
    if (!order && orderId) {
      const fetchOrder = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/orders/${orderId}`);
          let data = response.data;
          if (typeof data === "string") {
            const jsonStart = data.indexOf("{");
            if (jsonStart > 0) data = JSON.parse(data.substring(jsonStart));
          }
          if (data.success) setOrder(data.order);
        } catch (e) {
          console.error("Error fetching order:", e);
        } finally {
          setLoading(false);
        }
      };
      fetchOrder();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [orderId, order]);

  const row = (label, value) => (
    <div className="oot-sum-row" style={{ fontSize: 15 }}>
      <span>{label}</span><span style={{ color: "var(--oot-text)", fontWeight: 600 }}>{value}</span>
    </div>
  );

  return (
    <div>
      <NavBar />
      <div className="oot-page" style={{ maxWidth: 680 }}>
        {loading ? (
          <div className="oot-cart-empty">Loading order details…</div>
        ) : !order ? (
          <div className="oot-cart-list"><div className="oot-cart-empty">Order not found.</div></div>
        ) : (
          <div className="oot-auth-card" style={{ textAlign: "center" }}>
            <div style={{ width: 76, height: 76, borderRadius: "50%", background: "#e7f8ee", color: "var(--oot-ok)",
              display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 40 }}>✓</div>
            <h1 style={{ margin: "0 0 6px", fontSize: 28, fontWeight: 800 }}>Order Confirmed!</h1>
            <p className="sub" style={{ marginBottom: 22 }}>Thank you for your purchase.</p>

            <div className="oot-cart-list" style={{ textAlign: "left", padding: "10px 18px", marginBottom: 22 }}>
              {row("Order ID", order.order_id || orderId)}
              {row("Total Amount", `$${order.total?.toFixed(2) || "0.00"}`)}
              {row("Status", (order.status || "pending").toUpperCase())}
              {row("Shipping Address", order.shipping_address || "N/A")}
            </div>

            <div style={{ background: "var(--oot-accent-soft)", borderRadius: 12, padding: "16px 18px", textAlign: "left", marginBottom: 22 }}>
              <strong>Next steps</strong>
              <ul style={{ margin: "8px 0 0 18px", color: "var(--oot-muted)", lineHeight: 1.7 }}>
                <li>You'll receive a confirmation message shortly</li>
                <li>Track your order status in your account</li>
                <li>Expected delivery: 3–5 business days</li>
              </ul>
            </div>

            <div className="oot-pdp-actions" style={{ justifyContent: "center", margin: 0 }}>
              <button className="oot-btn oot-btn-primary oot-btn-lg" onClick={() => navigate("/")}>Continue shopping</button>
              <button className="oot-btn oot-btn-ghost oot-btn-lg" onClick={() => navigate("/MyOrders")}>View my orders</button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default OrderConfirmation;
